// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__zE001","skeleton_user":"Skeleton_skeleton_user__3eW0X","img":"Skeleton_img__zLXhg","content":"Skeleton_content__3tG1E","row":"Skeleton_row__1k3C-"};